import React from 'react';
import { hesitations } from '../data/content';
import { LeafSprig } from './decor/LeafSprig';
export function Problem() {
  return <section aria-labelledby="problem-title" className="bg-paper" data-id="element-224" data-mp="2peyz4ik9xwg9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-225" data-mp="2bgisermew5y4">
        <h2 id="problem-title" className="mx-auto max-w-3xl text-balance text-center font-display text-[38px] leading-[1.05] text-navy sm:text-[54px]" data-id="element-226" data-mp="2gesnl284z6jq">
          How Many Seeds of the Gospel Have You Planted This Week?
        </h2>

        <div className="mt-14 grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-227" data-mp="26hobxwbx2th6">
          <div className="space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-228" data-mp="1sphve94uqkh7">
            <p className="font-display text-2xl leading-snug text-navy sm:text-[28px]" data-id="element-229" data-mp="1snew0yht7ezt">Jesus told us to go and make disciples.</p>
            <p data-id="element-230" data-mp="1iqil6m4fugs3">
              But sometimes another day passes.
              <br data-id="element-231" data-mp="1it523cd7y8mz" />
              Then another week.
            </p>
            <p data-id="element-232" data-mp="1notwz2ean1cy">We go to work. We run errands. We visit stores. We talk to neighbors. We meet people everywhere…</p>
            <p className="border-l-4 border-coral pl-5 font-bold text-navy" data-id="element-233" data-mp="t83vvr6xvnuu">And yet another opportunity to share Christ passes us by.</p>
          </div>

          <div data-id="element-234" data-mp="12b50tok2j8wx">
            <p className="text-lg leading-relaxed text-ink-soft" data-id="element-235" data-mp="129k884hbe01p">
              Maybe you genuinely want to evangelize, but every time the opportunity comes, you think:
            </p>
            <ul className="mt-6 flex flex-wrap gap-3" data-id="element-236" data-mp="9l67hgyucpmg">
              {hesitations.map(h => <li key={h} className="rounded-2xl rounded-bl-sm bg-white px-5 py-3 font-display text-xl text-ink-soft shadow-card ring-1 ring-cream-line" data-id="element-237" data-mp="5kvzxzvehr5h">
                  “{h}”
                </li>)}
            </ul>
            <p className="mt-8 text-lg leading-relaxed text-ink-soft" data-id="element-238" data-mp="ejhihv0vh669">
              And before you know it, your daily routine has become the reason you keep postponing the mission God already gave you.
            </p>
          </div>
        </div>

        <div className="relative mx-auto mt-16 max-w-3xl rounded-[28px] bg-leaf-wash px-6 py-12 text-center sm:px-12" data-id="element-239" data-mp="1lyw8snytedcs">
          <LeafSprig className="mx-auto h-16 w-8 text-leaf-deep" data-id="element-240" data-mp="1qwxqp5ki86mo" />
          <p className="mt-4 text-lg font-semibold text-navy sm:text-xl" data-id="element-241" data-mp="1vofstwy9kd98">But sharing the Gospel doesn’t always have to begin with a sermon.</p>
          <p className="mt-3 font-display text-3xl leading-tight text-navy sm:text-[42px]" data-id="element-242" data-mp="20mhcok3ikglr">
            Sometimes… it begins with <span className="italic text-leaf-deep" data-id="element-243" data-mp="131bkpj3vjit8">one small seed.</span>
          </p>
        </div>
      </div>
    </section>;
}